<template>
    <div class="animate__animated animate__fadeInUp">
        <v-card-title><span v-html="$th('nav-main.imprint')"></span></v-card-title>

        <v-card-subtitle v-html="$th('g.imprint-foreword')">
            
        </v-card-subtitle>

        <loading-circle v-if="loading"></loading-circle>
        <v-card-text v-if="!loading" v-html="imprint" class="content-from-textarea"></v-card-text>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                imprint: "",
                loading: true,
            }
        },
        async beforeCreate() {
            let response = await this.func.ax("/php/getter.php", {
                func: "get_imprint",
            });
            this.imprint = response.imprint;
            this.loading = false;
        },
        metaInfo() {
            return {
                title: `${this.$t('meta.page-title-unformated')} - ${this.$t('meta.page-title-imprint')}`,
                meta : [{
                    name   : "description",
                    content: this.$t("meta.description"),
                }]
            }
        },
    }
</script>